import { useLocation, useNavigate } from "react-router-dom";
import "../styles/pay.scss"

const PayStatus = ({status}) => {
  const navigate = useNavigate();
  const location = useLocation()
  const lang = localStorage.getItem("i18nextLng") || "en";
  const params = new URLSearchParams(location.search);

  const message = params.get("message");

  let statuses = [
    {
        status: "success",
        icon: "/assets/images/icons/check-square.svg",
        text: "Վճարումը հաջողությամբ կատարվել է",
        textStyles: {
                  color: "#009313",
                  fontSize: "20px",
                  lineHeight: "45.6px",
                },
        navigateText : "Գլխավոր էջ",
        navigateRoute : "/",
    },
    {
        status: "failed",
        icon: "/assets/images/icons/danger.svg",
        text: "Վճարումը չի կատարվել",
        textStyles: {
                  color: "#BA0003",
                  fontSize: "20px",
                  lineHeight: "45.6px",
                },
        navigateText : "Վճարումների էջ",
        navigateRoute : `/${lang}/payment`,
        description : ""
    },
    {
        status: "pending",
        icon: "/assets/images/icons/danger-yellow.svg",
        text: "Վճարումը Ընթացքի մեջ է",
        textStyles: {
                  color: "#DF8A00",
                  fontSize: "20px",
                  lineHeight: "45.6px",
                },
        description : "Ձեր նշած էլ․ հասցեին կստանաք ծանուցում՝ վճարման ընթացքի վերաբերյալ։",
        navigateText : "Գլխավոր էջ",
        navigateRoute : "/",
    },
  ]

  let currentStatus = statuses.find((item) => item.status === status);
  

  const handleGoBack = (route) => {
    navigate(route);
    sessionStorage.removeItem("paymentData");
    sessionStorage.removeItem("cartData");
  };
  return (
    <section className="contact padding-t-60  padding-b-60 section-bg position-relative z-index-1 overflow-hidden">
      <div className="container container-two">
        <div className="row">
          <div className="col-12">
            <div className="card common-card p-4 d-flex flex-column justify-content-center align-items-center gap-4">
              <img
                src={currentStatus.icon}
                alt=""
                width={42}
                height={42}
              />
              <div>
                <p
                className="text-center fw-bold text-capitalize"
                style={currentStatus.textStyles}
              >
                {currentStatus.text}
              </p>

              {currentStatus.description && <p
                className="text-center fw-medium  theme-text"
                style={{
                  fontSize: "14px",
                  color: "black"
                }}
              >
                {currentStatus.description}
              </p>}
              {status == "failed" &&  message && <p
                className="text-center fw-medium theme-text  "
                style={{
                  fontSize: "14px",
                  color: "black"
                }}
              >
                {message}
              </p>}
              
              </div>

              <button
                id="demo-button-header"
                onClick={() => handleGoBack(currentStatus.navigateRoute)}
                className="d-flex gap-2 theme-text"
                style={{cursor:"pointer"}}
              >
                <span className="icon-left icon icon-filter">
                  <img src="/assets/images/icons/arrow-left.svg" alt="" />
                </span>
                {currentStatus.navigateText}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PayStatus;
